import { checkboxClasses, FormControl, FormLabel, Grid, typographyClasses } from '@mui/material';

import Checkbox from '../../../Checkbox';

export default function Checklist({ options, value, onChange, name, label }) {
	if (!options.length) return null;

	const isSubCategory = options.some(o => 'options' in o);
	const filterOptions = isSubCategory ? options.map(o => ({ ...o, label: `${o.label} ${label}` })) : options;

	const isSelected = option => {
		if (Array.isArray(value)) {
			return value.includes(option.value.toString());
		} else if (typeof value === 'string' || typeof value === 'number') {
			return option.value.toString() === value.toString();
		}

		return false;
	};

	const toggleValue = (checked, optionValue) => {
		const valArray = Array.isArray(value) ? value : value ? [value] : [];
		const newVal = checked ? [...valArray, optionValue] : valArray.filter(v => v !== optionValue);

		onChange(
			name,
			newVal.sort((a, b) => Number(a) - Number(b))
		);
	};

	const isAllSelected = options => {
		if (!value || !Array.isArray(value)) return false;

		const optionValues = options.map(option => option.value.toString());

		return optionValues.every(optionValue => value.includes(optionValue));
	};

	const toggleAll = (options, checked) => {
		const optionValues = options.map(option => option.value.toString());
		let newVal;

		if (checked) {
			newVal = value && Array.isArray(value) ? Array.from(new Set([...value, ...optionValues])) : [...optionValues];
		} else {
			newVal = value && Array.isArray(value) ? value.filter(v => !optionValues.includes(v)) : [];
		}

		onChange(
			name,
			newVal.sort((a, b) => Number(a) - Number(b))
		);
	};

	return (
		<FormControl fullWidth>
			{isSubCategory ? (
				<Grid container spacing={2}>
					{filterOptions.map((filter, index) => (
						<Grid item key={index}>
							<FormLabel id={`${filter.label}-checkbox-filters`} variant="list-filter">
								{filter.label}
							</FormLabel>
							<Grid container mt={0} spacing={2}>
								<Grid item xs={6}>
									<Input
										option={{ label: 'Select All', options: filter.options }}
										isSelectAll
										isAllSelected={isAllSelected}
										isSelected={isSelected}
										toggleAll={toggleAll}
										toggleValue={toggleValue}
									/>
								</Grid>
								{filter.options.map((option, index) => (
									<Grid item xs={6} key={index}>
										<Input option={option} isSelected={isSelected} toggleValue={toggleValue} isAllSelected={isAllSelected} toggleAll={toggleAll} />
									</Grid>
								))}
							</Grid>
						</Grid>
					))}
				</Grid>
			) : (
				<>
					<FormLabel id={`${label}-checkbox-filters`} variant="list-filter">
						{label}
					</FormLabel>
					<Grid container mt={0} spacing={2}>
						{filterOptions.map((option, index) => (
							<Grid item xs={6} key={index}>
								<Input option={option} isSelected={isSelected} toggleValue={toggleValue} isAllSelected={isAllSelected} toggleAll={toggleAll} />
							</Grid>
						))}
					</Grid>
				</>
			)}
		</FormControl>
	);
}

const Input = ({ option, isSelectAll = false, isSelected, toggleAll, toggleValue, isAllSelected }) => (
	<Checkbox
		label={option.label}
		value={option.value}
		checkboxProps={{
			checked: isSelectAll ? isAllSelected(option.options) : isSelected(option),
			disableRipple: true,
			value: option.value,
			onChange: e => (isSelectAll ? toggleAll(option.options, e.target.checked) : toggleValue(e.target.checked, e.target.value))
		}}
		sx={{
			mr: 0,
			alignItems: 'self-start',
			[`& .${typographyClasses.root}`]: { width: '135px' },
			[`& .${checkboxClasses.root}`]: { pr: 1, py: 0 }
		}}
	/>
);
